/* src/app/private/components/view/courses/courses.component.scss */
/*# sourceMappingURL=courses.component.css.map */
